export { default } from "./BodyScrollLock.js";
